import React, { useEffect, useState } from 'react';
import * as styles from './index.module.less';
import Dialog from '@/components/dialog';
import { PublicClose } from 'notta-web-icon';
import UsingBtn from '@/components/using-btn';
import { getUserBrowserLanguage } from '@/utils';

const LS_JP_HOME_PAGE_SELECTED_LANG = 'jp_home_page_selected_lang';

const MismatchLngDialog = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    localStorage.setItem(LS_JP_HOME_PAGE_SELECTED_LANG, 'ja');
    setIsOpen(false);
  };

  const handleToEnLinkClick = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const lang = getUserBrowserLanguage();
    const lsSelectedLng = localStorage.getItem(LS_JP_HOME_PAGE_SELECTED_LANG);
    if (lang !== 'ja' && lsSelectedLng !== 'ja') {
      setIsOpen(true);
    }
  }, []);

  return (
    <Dialog isOpen={isOpen} onClose={handleClose} mask>
      <div className={styles.wrapper}>
        {/* 关闭按钮 */}
        <button className={styles.close_btn} onClick={handleClose}>
          <PublicClose />
        </button>
        {/* 内容 */}
        <div className={styles.content_wrapper}>
          <p className={styles.title}>It seems the website language does not match your browser settings.</p>
          <p className={styles.desc}>
            We recommend visiting our English site that allows you to check content, services, and prices in a preferred
            language.
          </p>
        </div>
        {/* 其他页面链接 */}
        <div className={styles.btn_link_wrapper}>
          <UsingBtn
            type="primary"
            link="/en"
            label="Go to English site"
            isShowArrow
            className={styles.btn_item}
            labelClass={styles.btn_item_label}
            onClick={handleToEnLinkClick}
          />
          <UsingBtn
            type="link"
            onClick={handleClose}
            label="Stay on Japanese"
            className={styles.btn_item}
            labelClass={styles.btn_item_label}
          />
        </div>
      </div>
    </Dialog>
  );
};
export default MismatchLngDialog;
